import apiInterceptor from "../shared/apiInterceptor.js";

export async function deleteAppHelper({
  appId,
  environment,
  onSuccess, // callback function
  onError, // callback function
}) {
  try {
    const response = await apiInterceptor.delete(
      `${environment('VUE_APP_APIGEE_API_URL')}apps/${appId}`
    );

    if (onSuccess && typeof onSuccess === "function") {
      await onSuccess(response);
    }

    return response;
  } catch (error) {
    if (onError && typeof onError === "function") {
      onError(error);
    } else {
      // console.error("Error deleting app:", error);
    }
    throw error;
  }
}

export async function updateAppStatusHelper({
  appId,
  environment,
  action,
  onSuccess,
  onError,
}) {
  try {
    const response = await apiInterceptor.post(
      `${environment(
        'VUE_APP_APIGEE_API_URL'
      )}apps/${appId}/status?action=${action}`
    );

    if (onSuccess && typeof onSuccess === "function") {
      await onSuccess(response);
    }

    return response;
  } catch (error) {
    if (onError && typeof onError === "function") {
      onError(error);
    } else {
      // console.error("Error updating app status:", error);
    }
    throw error;
  }
}
